import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { modules } from "../data/modules";
import { useAuth } from "../contexts/AuthContext";
import { Capacitor } from "@capacitor/core";

export default function ModuleLanding() {
    const { user } = useAuth();
    const isNativeApp = Capacitor.isNativePlatform();
    const { moduleId } = useParams();

    const module = modules.find(
        (m) => m.id === moduleId
    );

    if (!module) {
        return <h2>Module not found</h2>;
    }

    const locked = !!module.membersOnly && !user;

    console.log({
        moduleId: module.id,
        membersOnly: module.membersOnly,
        user,
        locked
    });
    if (!module) {
        return <h2>Module not found</h2>;
    }

    return (
        <>
            <Helmet>
                <title>{module.seoTitle}</title>

                <meta
                    name="description"
                    content={module.seoDescription}
                />
            </Helmet>

            <div
                style={{
                    maxWidth: "900px",
                    margin: "0 auto",
                    padding: "2rem"
                }}
            >
                <div
                    style={{
                        textAlign: "center",
                        marginBottom: "3rem"
                    }}
                >
                    <img
                        src="/logo.png"
                        alt="Figure It Out"
                        style={{
                            width: "180px",
                            maxWidth: "70%",
                            marginBottom: "1rem"
                        }}
                    />

                    <h1>{module.title}</h1>

                    <p
                        style={{
                            fontSize: "1.2rem",
                            maxWidth: "650px",
                            margin: "0 auto",
                            lineHeight: "1.7"
                        }}
                    >
                        {module.description}
                    </p>

                    <Link
                        to={`/module/${module.id}`}
                        style={{
                            display: "inline-block",
                            marginTop: "2rem",
                            padding: "0.9rem 2rem",
                            background: "#1d3557",
                            color: "#fff",
                            textDecoration: "none",
                            borderRadius: "8px",
                            fontWeight: "600"
                        }}
                    >
                        Start Activities
                    </Link>
                </div>
                {locked && (
                    <div
                        style={{
                            background: "#fff8e1",
                            border: "1px solid #f0c36d",
                            borderRadius: "10px",
                            padding: "1.5rem",
                            marginBottom: "2rem",
                            textAlign: "center"
                        }}
                    >
                        <h3>Members Only</h3>

                        <p>
                            Create a free account to access these activities,
                            save your progress and use your Learning Journal.
                        </p>

                        <Link
                            to="/signup"
                            style={{
                                display: "inline-block",
                                marginRight: "1rem"
                            }}
                        >
                            Create Free Account
                        </Link>

                        <Link to="/login">
                            Log In
                        </Link>
                    </div>
                )}
                <h2>Activities</h2>

                {module.activities.map((activity) => (
                    <div
                        key={activity.id}
                        style={{
                            border: "1px solid #ddd",
                            borderRadius: "10px",
                            padding: "1rem",
                            marginBottom: "1rem"
                        }}
                    >
                        <h3>{activity.title}</h3>

                        {locked ? (
                            <button disabled>
                                🔒 Members Only
                            </button>
                        ) : (
                            <Link to={`/activity/${activity.id}`}>
                                Try Activity →
                            </Link>
                        )}
                    </div>
                ))}
                {!isNativeApp && (
                    <>
                        <h2
                            style={{
                                textAlign: "center",
                                marginTop: "3rem"
                            }}
                        >
                            Get the Figure It Out App
                        </h2>

                        <p
                            style={{
                                textAlign: "center",
                                maxWidth: "600px",
                                margin: "0 auto 1.5rem",
                                lineHeight: "1.6"
                            }}
                        >
                            Continue learning anywhere with the free Figure It Out app.
                        </p>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                gap: "1rem",
                                flexWrap: "wrap",
                                marginBottom: "2rem"
                            }}
                        >
                            <a
                                href="https://play.google.com/store/apps/details?id=now.figureitout.platform"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Get Figure It Out on Google Play"
                            >
                                <img
                                    src="/badges/google-play.png"
                                    alt="Get it on Google Play"
                                    style={{
                                        height: "56px",
                                        width: "auto"
                                    }}
                                />
                            </a>

                            <a
                                href="https://apps.apple.com/us/app/figure-it-out-think-better/id6792431196"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Download Figure It Out on the App Store"
                            >
                                <img
                                    src="/badges/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                                    alt="Download on the App Store"
                                    style={{
                                        height: "46px",
                                        width: "auto"
                                    }}
                                />
                            </a>
                        </div>
                    </>
                )}
                <section
                    style={{
                        marginTop: "3rem",
                        paddingTop: "2rem",
                        borderTop: "1px solid #ccc",
                        textAlign: "center"
                    }}
                >
                    <nav
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            gap: "1rem",
                            flexWrap: "wrap"
                        }}
                    >
                        <Link to="/about">About</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/privacy">Privacy</Link>
                        <Link to="/terms">Terms</Link>
                        <Link to="/credits">Credits</Link>
                    </nav>

                    <a
                        href="https://www.facebook.com/figureitout.au"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Follow Figure It Out on Facebook"
                        style={{
                            display: "inline-block",
                            marginTop: "1.5rem"
                        }}
                    >
                        <img
                            src="/facebook.png"
                            alt="Facebook"
                            style={{
                                width: "34px",
                                height: "34px"
                            }}
                        />
                    </a>

                    <p
                        style={{
                            marginTop: "1rem",
                            fontSize: "0.85rem",
                            color: "#666"
                        }}
                    >
                        © 2026 Figure It Out
                    </p>
                </section>
            </div>
        </>
    );
}